export default "__VITE_ASSET__QQFe8EnF__"